import api from '@/apis/di/bankInfoAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid CTMT
export const useBankInfoComboMultipleGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onBankInfoComboboxMultipleLoadData = (payload, row, column) => {
    payload.sort = 'bank_account';
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [{ Field: 'inactive', Value: false, Ors: ors }];
    payload.filter = extendFilter(payload.filter, extend);
    payload.columns += ',bank_info_id';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const bankInfoComboMultipleConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Số tài khoản',
        dataField: 'bank_account',
        width: 180,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên tài khoản NH, KB',
        dataField: 'bank_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 420,
      },
    ],
    displayField: 'bank_name',
    valueField: 'bank_name',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onBankInfoComboboxMultipleLoadData,
    modelValueField: 'bank_account',
  };

  return {
    bankInfoComboMultipleConfig,
    onBankInfoComboboxMultipleLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
